module.exports = __webpack_public_path__ + "static/media/dawghawtdawg-macbook-enter-score.b685ca28.jpg";